.uic-filter {
  display: inline-block;

  &__wrapper {
    background: var(--uic-list-background, #fff);
    box-shadow: var(--uic-list-box-shadow);
  }

  &__list {
    border: var(--uic-list-border);
    border-bottom: 0;
    box-sizing: border-box;
    min-height: 64px;
    position: relative;
  }

  &__scroller {
    max-height: var(--uic-list-popover-max-height);
    max-width: var(--uic-list-popover-max-width);

    > .uic-virtual-scroll__scroller {
      max-height: var(--uic-list-popover-max-height);
    }
  }

  &__item {
    padding-left: 12px;
  }

  &__search-wrapper {
    width: 100%;
    box-sizing: border-box;
    display: flex;
    flex-flow: row nowrap;
    align-items: center;
    border: var(--uic-list-border);
    border-bottom: 0;
    height: var(--uic-list-item-height);

    .uic-checkbox__wrapper {
      padding-left: 20px;
      padding-right: 0;
    }
  }

  &__search {
    border: var(--uic-list-border);
    border-bottom: 0;
    padding: 12px;
    width: 100%;

    &-wrapper & {
      border: 0 none;
      flex: 1 1 auto;
      width: auto;
    }
  }

  &__value {
    color: var(--uic-color-black);
    font-size: var(--uic-font-size-normal);
    font-weight: var(--uic-font-weight-semibold);
    line-height: var(--uic-line-height-normal);
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  &__icon {
    --uic-icon-width: var(--uic-icon-dimensions-default);
    --uic-icon-height: var(--uic-icon-dimensions-default);
    align-items: center;
    color: var(--uic-color-black);
    display: flex;
    height: 100%;
    justify-content: center;
    position: absolute;
    right: 0;
    top: 0;
    width: 50px;
  }

  &__label {
    color: var(--uic-color-black);
    display: block;
    font-size: var(--uic-font-size-normal);
    font-weight: var(--uic-font-size-normal);
    line-height: var(--uic-line-height-normal);
    overflow: hidden;
    padding-bottom: 4px;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  &__button {
    background: var(--uic-color-white);

    border: 0;
    cursor: pointer;
    outline: 2px solid transparent;
    outline-offset: -2px;
    overflow: hidden;
    padding: 13px 45px 11px 8px;
    padding-left: 8px;
    padding-right: 45px;
    position: relative;
    text-align: left;
    text-overflow: ellipsis;
    white-space: nowrap;
    width: 100%;

    &:focus {
      outline-color: var(--uic-color-blue2);
    }

    &:active .uic-filter__value,
    &:active .uic-filter__icon,
    &:hover .uic-filter__value,
    &:hover .uic-filter__icon {
      color: var(--uic-color-blue3);
    }

    &:disabled .uic-filter__value,
    &:disabled .uic-filter__icon {
      color: var(--uic-color-grey5);
    }
  }

  &__no-search-results {
    @include font(normal);
    box-sizing: border-box;
    color: var(--uic-color-grey3a75);
    display: none;
    height: 100%;
    left: 0;
    min-height: 64px;
    padding: 12px;
    position: absolute;
    top: 0;
    width: 100%;
  }

  &__no-search-results-default {
    align-items: center;
    display: flex;
    flex-direction: row;
    gap: 8px;
  }

  &--no-results &__no-search-results {
    display: block;
  }

  &--open {
    .uic-filter__icon {
      transform: rotate(180deg);
    }
  }

  &__item--nested {
    padding-left: 28px;
  }

  &__item--separated::after {
    background: var(--uic-color-grey2);
    bottom: 0;
    content: '';
    height: 1px;
    left: 0;
    position: absolute;
    right: 0;
  }
}
